<section>
  <h5 data-cy="empty-state-title">
    {{ title }}
  </h5>
  <div
    class="subtitles"
    *ngFor="let subtitle of subtitles; let i = index"
    [innerHTML]="subtitle"
    [attr.data-cy]="'empty-state-subtitle-' + i"
  ></div>
  <div class="button-container">
    <ion-button
      *ngFor="let button of buttons; let i = index"
      [attr.data-cy]="'empty-state-action-' + i"
      [class]="button.color"
      (click)="button.action && handleAction(button.action, button.params)"
    >
      {{ button.text }}
      <ion-icon
        *ngIf="button.iconName || button.iconSrc"
        [name]="button.iconName"
        [src]="button.iconSrc"
      >
      </ion-icon>
    </ion-button>
  </div>
</section>
